// @ts-ignore
// @ts-nocheck
import axios, { AxiosRequestConfig, Method } from 'axios';
import { toast } from 'react-toastify';
import { scanHeaders } from 'services/scanHeaders';
import { marcarSelecaoPendente } from 'components/Granel/AddressGate/services';
import { store } from 'store/index';
import { customerStatusInvalidate } from 'store/actions/customerStatus-actions';
import api from './api';

export const requestGetAccessToken = async (): Promise<any> => {
  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };
  const parameters = {
    method: 'POST' as Method,
    headers: header,
  };
  const body = {
    grant_type: 'client_credentials',
  };

  let accessToken = '';

  try {
    const response = await api.post(
      'industrial/customer/v1/users/authentications',
      body,
      parameters
    );
    accessToken = response.data.access_token;
  } catch (error) {
    // @ts-ignore
    const erro = error.response;
    if (erro.status === 400) {
      toast.error('Autenticação inválida');
    }
    if (erro) {
      // @ts-ignore
      const { message } = error.response.data;
      // @ts-ignore
      if (error.response.status !== 401) {
        toast.error(message);
      }
      // @ts-ignore
    } else if (error.response.status !== 401) {
      toast.error('Ocorreu um erro interno na aplicação');
    }
  }

  return accessToken;
};

export const requestOauth = async (
  login: string,
  password: string,
  token: string | null,
  accessToken: string,
  dispatch: any,
  getSigninInfo: any
): Promise<any> => {
  const mfaToken =
    localStorage.getItem('@UltragazEmpresarial:X-Mfa-Hash') ?? null;

  const userCustomerRelationshipId =
    localStorage.getItem('@UltragazEmpresarial:userCustomerRelationshipId') ||
    undefined;

  const req = axios.create({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'pt-BR',
      client_id: process.env.REACT_APP_CLIENT_ID,
      ...scanHeaders,
      'MFA-Enabled': true,
      ...(mfaToken && { 'x-mfa-hash': mfaToken }),
    },
    baseURL: process.env.REACT_APP_API_URL,
  });

  const header = {
    'Content-Type': 'application/json',
    'Accept-Language': 'pt-BR',
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    access_token: accessToken,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  } as AxiosRequestConfig;

  const body = {
    username: login,
    password,
    grant_type: 'password',
    ...(!mfaToken && token && { token }),
    ...(userCustomerRelationshipId && { userCustomerRelationshipId }),
  };

  const response = await req.post(
    'industrial/customer/v1/users/authentications',
    body,
    parameters
  );

  if (response.status === 201) {
    const tokenMFA = response.headers['x-mfa-hash'];

    if (tokenMFA) {
      localStorage.setItem('@UltragazEmpresarial:X-Mfa-Hash', tokenMFA);
    }
    dispatch(getSigninInfo(response.data));

    return response.data;
  }
  return null;
};

export const removeAllItemsLocalStorage = (): void => {
  localStorage.removeItem('@UltragazEmpresarial:customerCode');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
  localStorage.removeItem('@UltragazEmpresarial:customerName');
  localStorage.removeItem('@UltragazEmpresarial:refreshToken');
  localStorage.removeItem('@UltragazEmpresarial:accessToken');
  localStorage.removeItem('@UltragazEmpresarial:userName');
  localStorage.removeItem('@UltragazEmpresarial:document');
  localStorage.removeItem('@UltragazEmpresarial:customerId');
  localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
  localStorage.removeItem('@UltragazEmpresarial:loginEmail');
  localStorage.removeItem('@UltragazEmpresarial:customerAddressLine');
  localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
  localStorage.removeItem('@UltragazEmpresarial:customerType');
};

const requestGetInstallbases = async (
  token: string,
  userId: string,
  handleSelectAddress: any,
  history: any
): Promise<any> => {
  try {
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };

    const parameters = {
      method: 'GET',
      headers: header,
    } as AxiosRequestConfig;

    const response = await api.get(
      `industrial/customer/v1/users/${userId}/customers?&_offset=0&_limit=1000&address_type=SHIP_TO`,
      parameters
    );

    const responseData = response.data;
    // @ts-ignore
    let adresses = [];
    // @ts-ignore
    responseData.map((address) => {
      // @ts-ignore
      address.customerAddress.map((base) => {
        // @ts-ignore
        adresses = [...adresses, { base, address }];
        return null;
      });

      return null;
    });
    // @ts-ignore
    if (adresses) {
      // @ts-ignore
      const { base, address } = adresses[0];

      handleSelectAddress(
        base.code,
        base.siteId,
        address.customerCode,
        address.customerId,
        address.name,
        base.addressLine,
        base.addressNumber,
        address.userCustomerRelationshipId,
        address.document
      );

      if (adresses.length > 1) {
        // Mais de um endereço não desvia mais para /endereco: o portal abre e
        // o AddressGate cobre a home com a modal de escolha obrigatória, que
        // é quem faz o change-profile do endereço escolhido.
        marcarSelecaoPendente();
      } else {
        await requestChangeProfile(token, address.userCustomerRelationshipId);
      }

      history.push('/portal');
    }
  } catch (error) {
    // @ts-ignore
    toast.error(error.response.data.message);
  }
};

export const requestGetUserName = async (
  token: string,
  userId: string,
  login: string,
  setUserInfos: any,
  handleSelectAddress: any,
  history: any
): Promise<any> => {
  try {
    const header = {
      'Content-Type': 'application/json',
      access_token: token,
    };

    const parameters = {
      method: 'GET',
      headers: header,
    } as AxiosRequestConfig;

    const response = await api.get(
      `industrial/customer/v1/users/${userId}/contacts?contact=${login}`,
      parameters
    );

    if (response.data && response.data.length > 0) {
      const responseData = response.data[0];
      localStorage.setItem(
        '@UltragazEmpresarial:contactIdSf',
        responseData.contactIdSf
      );
      if (responseData.name) {
        setUserInfos({ userName: responseData.name });
      }
    }
    requestGetInstallbases(token, userId, handleSelectAddress, history);
  } catch (error) {
    // @ts-ignore
    toast.error(error.response.data.message);
  }
};

export const requestGetUserInfos = async (
  login: string,
  accessToken: string,
  dispatch: any,
  handleUserId: any,
  setUserInfos: any,
  handleSelectAddress: any,
  history: any
): Promise<any> => {
  try {
    const header = {
      'Content-Type': 'application/json',
      access_token: accessToken,
    };

    const parameters = {
      method: 'GET',
      headers: header,
    } as AxiosRequestConfig;

    const response = await api.get(
      `industrial/customer/v1/users/?login=${login}&is-active=true`,
      parameters
    );

    if (response.data && response.data.length > 0) {
      const responseData = response.data[0];
      const { userId, loginCount } = responseData;
      localStorage.setItem('@UltragazEmpresarial:loginCount', loginCount || '');
      dispatch(handleUserId(userId));
      requestGetUserName(
        accessToken,
        userId,
        login,
        setUserInfos,
        handleSelectAddress,
        history
      );
      localStorage.setItem('@UltragazEmpresarial:userId', userId);
    } else {
      removeAllItemsLocalStorage();
      toast.error(
        'Não foi possível encontrar os dados correspondentes deste e-mail.'
      );
    }
  } catch (error) {
    // @ts-expect-error
    toast.error(error.response.data.message);
  }
};

const requestChangeProfile = (
  token: string,
  userCustomerRelationshipId: string
): Promise<any> => {
  store.dispatch(customerStatusInvalidate());

  const username = localStorage.getItem('@UltragazEmpresarial:loginEmail');

  const header = {
    'Content-Type': 'application/json',
    access_token: token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  } as AxiosRequestConfig;

  const body = {
    userCustomerRelationshipId,
    username,
  };

  return api
    .post('industrial/customer/v1/users/change-profile', body, parameters)
    .then((res) => {
      const response = res.data;

      localStorage.setItem(
        '@UltragazEmpresarial:accessToken',
        response.access_token
      );

      const headerGet = {
        'Content-Type': 'application/json',
        access_token: response.access_token,
      };

      const parametersGet = {
        method: 'GET',
        headers: headerGet,
      } as AxiosRequestConfig;

      return api
        .get('industrial/customer/v1/customers/me', parametersGet)
        .then((resGet) => {
          const responseGet = resGet.data;
          localStorage.setItem(
            '@UltragazEmpresarial:document',
            responseGet.document
          );
        });
    });
};
